export default __webpack_public_path__ + "static/media/progress.92eb50b8.png";